import React from "react";
import "./Embed.scss";

const Embed = ({ URL }) => {
  return (
    <div className="embed-container">
      <iframe
        src={URL}
        frameBorder={0}
        allowFullScreen
      ></iframe>
    </div>
  );
};

Embed.propTypes = {
  URL: URL,
};

export default Embed;
